"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sideNav = _interopRequireDefault(require("../../components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _join_form = _interopRequireDefault(require("../../components/join_form.vue"));
var _downguid = _interopRequireDefault(require("../../components/downguid.vue"));
var _default = exports.default = {
  name: 'businessjoin',
  components: {
    footNav: _footNav.default,
    sideNav: _sideNav.default,
    joinForm: _join_form.default,
    downGuid: _downguid.default
  },
  data: function data() {
    return {};
  },
  methods: {
    // 锚点滚动
    goAnchor: function goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        // 平滑过渡
        block: "start" // 上边框与视窗顶部平齐。默认值
      });
    }
  }
};